import { queryOptions } from '@tanstack/react-query'
import { getMemberProfile, getMyProfile, listTeam, listUsers } from '../lib/api'

export const staffKeys = {
	all: ['staff'] as const,
	users: () => [...staffKeys.all, 'users'] as const,
	team: () => [...staffKeys.all, 'team'] as const,
	myProfile: () => [...staffKeys.all, 'my-profile'] as const,
	memberProfile: (userId: string) => [...staffKeys.all, 'member-profile', userId] as const,
}

export const usersQuery = () => queryOptions({ queryKey: staffKeys.users(), queryFn: listUsers })

export const teamQuery = () => queryOptions({ queryKey: staffKeys.team(), queryFn: listTeam })

export const myProfileQuery = () => queryOptions({ queryKey: staffKeys.myProfile(), queryFn: getMyProfile })

export const memberProfileQuery = (userId: string) =>
	queryOptions({ queryKey: staffKeys.memberProfile(userId), queryFn: () => getMemberProfile(userId), enabled: userId !== '' })
